/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secure_Login_InstructionsInputs */

const en_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email address to get a secure login link. Use this link to either create or access a Premium account, and complete your purchase.`)
};

const id_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat email Anda untuk mendapatkan tautan login yang aman. Gunakan tautan ini untuk membuat atau mengakses akun Premium, dan selesaikan pembelian Anda.`)
};

const ms_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukkan alamat emel anda untuk mendapatkan pautan log masuk selamat. Gunakan pautan ini untuk sama ada membuat atau mengakses akaun Premium, dan melengkapkan pembelian anda.`)
};

const ca_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introdueix la teva adreça de correu electrònic per obtenir un enllaç de sessió segur. Utilitza aquest enllaç per crear o accedir a un compte Premium i completar la teva compra.`)
};

const cs_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte svou emailovou adresu, abyste obdrželi bezpečný odkaz pro přihlášení. Tento odkaz použijte buď k vytvoření nebo k přístupu k prémiovému účtu a dokončete nákup.`)
};

const da_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast din e-mailadresse for at få et sikkert login-link. Brug dette link til enten at oprette eller få adgang til en Premium-konto og fuldføre dit køb.`)
};

const de_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre E-Mail-Adresse ein, um einen sicheren Anmelde-Link zu erhalten. Verwenden Sie diesen Link, um entweder ein Premium-Konto zu erstellen oder darauf zuzugreifen und Ihren Kauf abzuschließen.`)
};

const et_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turvalise sisselogimislingi saamiseks sisestage oma e-posti aadress. Kasutage seda linki, et kas luua või pääseda Premium kontole ja lõpule viia oma ost.`)
};

const es_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu dirección de correo electrónico para obtener un enlace seguro de inicio de sesión. Usa este enlace para crear o acceder a una cuenta Premium y completar la compra.`)
};

const fr_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez votre adresse e-mail pour obtenir un lien de connexion sécurisé. Utilisez ce lien pour créer ou accéder à un compte Premium et terminer votre achat.`)
};

const hr_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unesite svoju e-mail adresu za dobivanje sigurne veze za prijavu. Koristite ovu vezu za stvaranje ili pristup Premium računu te za dovršavanje vaše kupnje.`)
};

const it_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il tuo indirizzo email per ottenere un link di accesso sicuro. Usa questo link per creare o accedere a un account Premium e completare il tuo acquisto.`)
};

const lv_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ievadiet savu e-pasta adresi, lai saņemtu drošās pieslēgšanās saiti. Izmantojiet šo saiti, lai izveidotu vai piekļūtu Premium kontam un pabeigtu pirkumu.`)
};

const lt_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įveskite savo el. pašto adresą, kad gautumėte saugią prisijungimo nuorodą. Naudokite šią nuorodą paskyrai sukurti ar prieiti prie Premium paskyros ir užbaigti pirkimą.`)
};

const hu_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adja meg az e-mail címét egy biztonságos bejelentkezési link megszerzéséhez. Használja ezt a linket a Prémium fiók létrehozásához vagy eléréséhez, és a vásárlás befejezéséhez.`)
};

const nl_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je e-mailadres in om een beveiligde inloglink te ontvangen. Gebruik deze link om een Premium-account aan te maken of toegang te verkrijgen en je aankoop te voltooien.`)
};

const nb_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn e-postadressen din for å få tilsendt en innloggingslenke. Bruk denne lenken til å enten opprette eller få tilgang til en Premium-konto, og fullfør kjøpet ditt.`)
};

const pl_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj swój adres e-mail, aby otrzymać bezpieczny link do zalogowania. Użyj tego linku, aby utworzyć lub uzyskać dostęp do konta Premium i dokończyć zakup.`)
};

const pt_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite seu endereço de e-mail para obter um link de login seguro. Use esse link para criar ou acessar uma conta Premium e concluir sua compra.`)
};

const ro_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduceți adresa dvs. de e-mail pentru a obține un link sigur de autentificare. Folosiți acest link fie pentru a crea un cont premium, fie pentru a accesa unul și a finaliza achiziția.`)
};

const sk_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadajte svoju e-mailovú adresu, aby ste dostali bezpečný odkaz na prihlásenie. Pomocou tohto odkazu si môžete vytvoriť alebo prejsť na Prémiový účet a dokončiť svoj nákup.`)
};

const sl_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vnesite svoj e-poštni naslov, da dobite varno povezavo za prijavo. Uporabite to povezavo za ustvarjanje ali dostop do Premium računa in dokončajte nakup.`)
};

const fi_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä sähköpostiosoitteesi saadaksesi suojatun kirjautumislinkin. Käytä tätä linkkiä luodaksesi tai käyttääksesi Premium-tiliä ja saadaksesi oston päätökseen.`)
};

const sv_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange din e-postadress för att få en säker inloggningslänk. Använd denna länk för att antingen skapa eller komma åt ett Premium-konto och slutföra ditt köp.`)
};

const vi_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập địa chỉ email của bạn để nhận liên kết đăng nhập bảo mật. Sử dụng liên kết này để tạo hoặc truy cập tài khoản Premium, và hoàn tất việc mua của bạn.`)
};

const tr_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenli bir oturum açma bağlantısı almak için e-posta adresinizi girin. Bu bağlantıyı kullanarak bir Premium hesap oluşturabilir veya erişebilir ve satın alımınızı tamamlayabilirsiniz.`)
};

const el_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εισάγετε τη διεύθυνση email σας για να λάβετε έναν ασφαλή σύνδεσμο σύνδεσης. Χρησιμοποιήστε αυτόν τον σύνδεσμο για να δημιουργήσετε ή να αποκτήσετε πρόσβαση σε έναν premium λογαριασμό και να ολοκληρώσετε την αγορά σας.`)
};

const bg_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Въведете своя имейл адрес, за да получите защитена връзка за вход. Използвайте тази връзка, за да създадете или получите достъп до Premium акаунт и да завършите покупката си.`)
};

const ru_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите свой адрес электронной почты, чтобы получить безопасную ссылку для входа. Используйте эту ссылку для создания или доступа к премиум-аккаунту и завершения покупки.`)
};

const sr_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Унесите своју емаил адресу да добијете сигурну везу за пријаву. Користите ову везу да креирате или приступите Премиум налогу, као и да завршите куповину.`)
};

const uk_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть адресу електронної пошти, щоб отримати захищене посилання для входу. Використовуйте це посилання, щоб створити або отримати доступ до Преміум-облікового запису та завершити покупку.`)
};

const ka_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეიყვანეთ თქვენი მეილის მისამართი, რათა მიიღოთ უსაფრთხო შესვლის ბმული. გამოიყენეთ ეს ბმული პრემიალური ანგარიშის შესაქმნელად ან მისთვის შესავადგენად და შესყიდვის დასასრულებლად.`)
};

const hi_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुरक्षित लॉगिन लिंक प्राप्त करने के लिए अपना ईमेल पता दर्ज करें। इस लिंक का उपयोग करके एक प्रीमियम खाता बनाएँ या पहुँच प्राप्त करें, और अपनी खरीदारी पूरी करें।`)
};

const th_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ป้อนที่อยู่อีเมลของคุณเพื่อรับลิงก์เข้าสู่ระบบที่ปลอดภัย ใช้ลิงก์นี้เพื่อสร้างหรือเข้าถึงบัญชี Premium และทำการซื้อให้เสร็จสมบูรณ์`)
};

const ko_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 로그인 링크를 받으려면 이메일 주소를 입력하세요. 이 링크를 사용하여 프리미엄 계정을 생성하거나 액세스하고, 구매를 완료하세요.`)
};

const zh_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的电子邮件地址以获取安全登录链接。您可以使用此链接创建或访问 Premium 账户，并完成您的购买。`)
};

const zh_tw_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入您的電子郵件地址以獲取安全登入連結。請使用此連結建立或登入您的高級版帳戶，完成購買流程。`)
};

const ja_secure_login_instructions = /** @type {(inputs: Secure_Login_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを入力して、セキュアログインリンクを取得してください。このリンクを使用してプレミアムアカウントを作成またはアクセスし、購入を完了できます。`)
};

/**
* | output |
* | --- |
* | "Enter your email address to get a secure login link. Use this link to either create or access a Premium account, and complete your purchase." |
*
* @param {Secure_Login_InstructionsInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const secure_login_instructions = /** @type {((inputs?: Secure_Login_InstructionsInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secure_Login_InstructionsInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_secure_login_instructions(inputs)
	if (locale === "ms") return ms_secure_login_instructions(inputs)
	if (locale === "ca") return ca_secure_login_instructions(inputs)
	if (locale === "cs") return cs_secure_login_instructions(inputs)
	if (locale === "da") return da_secure_login_instructions(inputs)
	if (locale === "de") return de_secure_login_instructions(inputs)
	if (locale === "et") return et_secure_login_instructions(inputs)
	if (locale === "es") return es_secure_login_instructions(inputs)
	if (locale === "fr") return fr_secure_login_instructions(inputs)
	if (locale === "hr") return hr_secure_login_instructions(inputs)
	if (locale === "it") return it_secure_login_instructions(inputs)
	if (locale === "lv") return lv_secure_login_instructions(inputs)
	if (locale === "lt") return lt_secure_login_instructions(inputs)
	if (locale === "hu") return hu_secure_login_instructions(inputs)
	if (locale === "nl") return nl_secure_login_instructions(inputs)
	if (locale === "nb") return nb_secure_login_instructions(inputs)
	if (locale === "pl") return pl_secure_login_instructions(inputs)
	if (locale === "pt") return pt_secure_login_instructions(inputs)
	if (locale === "ro") return ro_secure_login_instructions(inputs)
	if (locale === "sk") return sk_secure_login_instructions(inputs)
	if (locale === "sl") return sl_secure_login_instructions(inputs)
	if (locale === "fi") return fi_secure_login_instructions(inputs)
	if (locale === "sv") return sv_secure_login_instructions(inputs)
	if (locale === "vi") return vi_secure_login_instructions(inputs)
	if (locale === "tr") return tr_secure_login_instructions(inputs)
	if (locale === "el") return el_secure_login_instructions(inputs)
	if (locale === "bg") return bg_secure_login_instructions(inputs)
	if (locale === "ru") return ru_secure_login_instructions(inputs)
	if (locale === "sr") return sr_secure_login_instructions(inputs)
	if (locale === "uk") return uk_secure_login_instructions(inputs)
	if (locale === "ka") return ka_secure_login_instructions(inputs)
	if (locale === "hi") return hi_secure_login_instructions(inputs)
	if (locale === "th") return th_secure_login_instructions(inputs)
	if (locale === "ko") return ko_secure_login_instructions(inputs)
	if (locale === "zh") return zh_secure_login_instructions(inputs)
	if (locale === "zh-tw") return zh_tw_secure_login_instructions(inputs)
	if (locale === "ja") return ja_secure_login_instructions(inputs)
	return en_secure_login_instructions(inputs)
});